var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedInIcon = function SvgLinkedInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.294 8.472c3.905 0 4.625 2.615 4.625 6.096l.14 5.984a1 1 0 0 1-.999 1.024h-1.999a1 1 0 0 1-1-1v-5.24c0-1.488-.023-3.384-1.999-3.384-1.999 0-2.301 1.608-2.301 3.288v5.36a1 1 0 0 1-1 1H9.902a1 1 0 0 1-1-1V9.784a1 1 0 0 1 1-1h1.696a1 1 0 0 1 1 1v.752h.047c.511-1.008 1.766-2.064 3.649-2.064M2.626 9.784a1 1 0 0 1 1-1h1.859a1 1 0 0 1 1 1V20.6a1 1 0 0 1-1 1H3.626a1 1 0 0 1-1-1zM4.556 2.4c-1.232 0-2.232 1.032-2.232 2.304s1 2.328 2.232 2.328 2.231-1.056 2.231-2.328-1-2.304-2.231-2.304"
  })));
};
export default SvgLinkedInIcon;